// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function IconInstagram(Props) {
  return React.createElement("svg", {
    height: "22",
    width: "26",
    fill: "none",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.66336 3.3002C6.84438 3.3002 5.3002 4.86533 5.3002 6.88413V15.1163C5.3002 17.1351 6.84438 18.7002 8.66336 18.7002H17.337C19.156 18.7002 20.7002 17.1351 20.7002 15.1163V6.88413C20.7002 4.86533 19.156 3.3002 17.337 3.3002H8.66336ZM3.7002 6.88413C3.7002 4.06058 5.88383 1.7002 8.66336 1.7002H17.337C20.1166 1.7002 22.3002 4.06058 22.3002 6.88413V15.1163C22.3002 17.9398 20.1166 20.3002 17.337 20.3002H8.66336C5.88383 20.3002 3.7002 17.9398 3.7002 15.1163V6.88413Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.0002 8.3002C11.509 8.3002 10.3002 9.50903 10.3002 11.0002C10.3002 12.4914 11.509 13.7002 13.0002 13.7002C14.4914 13.7002 15.7002 12.4914 15.7002 11.0002C15.7002 9.50903 14.4914 8.3002 13.0002 8.3002ZM8.7002 11.0002C8.7002 8.62537 10.6254 6.7002 13.0002 6.7002C15.375 6.7002 17.3002 8.62537 17.3002 11.0002C17.3002 13.375 15.375 15.3002 13.0002 15.3002C10.6254 15.3002 8.7002 13.375 8.7002 11.0002Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M17.8434 7.35845C18.4506 7.35845 18.9429 6.86596 18.9429 6.25845C18.9429 5.65093 18.4506 5.15845 17.8434 5.15845C17.2362 5.15845 16.7439 5.65093 16.7439 6.25845C16.7439 6.86596 17.2362 7.35845 17.8434 7.35845Z",
    fill: "currentColor"
  }));
}
IconInstagram.displayName = "IconInstagram";
var make = IconInstagram;
export { make };
/* react Not a pure module */